import { html, css } from "lit";
import { customElement, property } from "lit/decorators.js";
import { BaseElement } from "../BaseElement";
import { IMedia } from "../../models/Models";

@customElement("ds-media-diff")
export class MediaDiff extends BaseElement {
    static override styles = [
        css`
            :host {
                display: block;
            }

            ds-media {
                height: 200px;
            }
        `,
    ];
    @property({ type: Object }) media?: IMedia;

    override render() {
        if (this.media) {
            return html`<ds-media .media=${this.media}></ds-media>`;
        }
        return html``;
    }
}
